import { lazy } from 'react';

const EmployeeEdit = lazy(() => import('./EmployeeEdit'));

export default EmployeeEdit;
